<template>
  <div>
    <template v-if="is_edit" v-click-outside="on_cancel">
      <z-form ref="form" class="z-form" @submit.native.prevent="save">
        <z-form-input :rules="{ max: 40 }" :show_errors="false">
          <base-input
            v-model.trim="local_value"
            :loading="loading"
            @on-save="on_save"
            @on-cancel="on_cancel"
          />
        </z-form-input>
      </z-form>
    </template>
    <template v-else>
      <slot :value="value"></slot>
    </template>
  </div>
</template>

<script>
  import BaseInput from '@shared/components/editable-base-input';
  import { directive as clickOutside } from 'v-click-outside-x';
  import { mapActions } from 'vuex';
  import { EditableProps } from '@shared/mixins/editable-props';
  import { DataBaseGroupService } from '@db/services/GroupService';

  export default {
    components: {
      BaseInput
    },

    directives: {
      clickOutside
    },

    mixins: [EditableProps],

    data: () => ({
      loading: false
    }),

    methods: {
      ...mapActions('db/groups/table', ['updateItemById']),

      on_save: function() {
        this.$refs.form.validate().then(is_valid => {
          if (is_valid) {
            this.loading = true;
            DataBaseGroupService.editItem(this.id, { name: this.local_value })
              .then(res => {
                this.updateItemById(res);
                this.$emit('on-save', res);
                this.$emit('on-complete');
              })
              .finally(() => (this.loading = false));
          }
        });
      },

      on_cancel: function() {
        this.local_value = this.value;
        this.$emit('on-cancel');
        this.$emit('on-complete');
      }
    }
  };
</script>
